module.exports = __webpack_public_path__ + "assets/0edba43f64aa03eb376f1c4a27c570a3.png";